var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.252 103.068a57.104 57.104 0 0 0-28.485-27.254 56.678 56.678 0 0 0-22.656-4.703H56.889a56.678 56.678 0 0 0-22.656 4.703 57.108 57.108 0 0 0-28.485 27.254A56.65 56.65 0 0 0 0 128v256c0 17.085 7.544 32.4 19.469 42.828 10.004 8.748 23.089 14.061 37.42 14.061h398.222c14.332 0 27.416-5.312 37.42-14.061C504.456 416.4 512 401.085 512 384V128a56.65 56.65 0 0 0-5.748-24.932z",
    fill: "#36f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 256.266l-.416.034L19.469 426.828c10.004 8.748 23.089 14.061 37.42 14.061h398.222c14.332 0 27.416-5.312 37.42-14.061L256.416 256.3l-.416-.034zM256 256.266l.33-.028L256 256l-.33.238z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 256.266l-.33-.028L0 235.11v42.311L255.584 256.3zM256 256.266l.416.034L512 277.421V235.11l-255.67 21.128zM34.233 75.814a57.108 57.108 0 0 0-28.485 27.254L256 256 34.233 75.814zM506.252 103.068a57.104 57.104 0 0 0-28.485-27.254L256 256l250.252-152.932zM277.333 71.111h-42.666L256 256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRe);
export default __webpack_public_path__ + "static/media/re.9661d84f7be459dd252b9fc089208626.svg";
export { ForwardRef as ReactComponent };